import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

const Navbar = () => {

  const { lang } = useParams();
  const currentLang = lang || "en";

  const navbarLinks = [
    { name: "Features", link: `/${currentLang}/features`, internal: true },
    { name: "Download", link: `/${currentLang}/download`, internal: true },
    { name: "FAQ", link: `/${currentLang}/faq`, internal: true },
    { name: "Help", link: "https://help.aronium.com/hc", internal: true },
    { name: "Sign In", link: "https://my.aronium.com", internal: false, target: "_blank" },
    { name: "Partners", link: `/${currentLang}/partners`, internal: true },
    { name: "Contact", link: `/${currentLang}/contact`, internal: true },

  ];
  let [open, setOpen] = useState(false);
  let [top, setTop] = useState(true);

  const toggle = () => setOpen(!open);

  useEffect(() => {
    const scrollHandler = () => {
      window.scrollY > 10 ? setTop(false) : setTop(true)
    };
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setOpen(false);
      }
    };
    window.addEventListener('scroll', scrollHandler);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', handleResize);
    }
  }, [top]);

  return (
    <nav style={{ zIndex: 99 }} className={`w-full fixed relative top-0 left-0 sticky bg-white transition-all ${!top && `shadow-md`} print:!hidden`}>
      <div className='max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-2'>

        <div className='cursor-pointer flex items-center gap-1'>
          <Link to={`/${currentLang}`} className='ml-2 hover:no-underline'><img alt='Home' className='w-40' src={`${process.env.PUBLIC_URL}/images/logo.png`}></img></Link>
        </div>

        <button onClick={toggle} className='absolute right-4 cursor-pointer md:hidden w-7 h-7 flex flex-col justify-center items-center'>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-8 h-8">
            <path d="m11 16.745c0-.414.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75h-9.5c-.414 0-.75-.336-.75-.75zm-9-5c0-.414.336-.75.75-.75h18.5c.414 0 .75.336.75.75s-.336.75-.75.75h-18.5c-.414 0-.75-.336-.75-.75zm4-5c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75z" fillRule="nonzero" />
          </svg>
        </button>

        <ul className={`md:flex md:items-center md:pb-0 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 px-5 top-12 ${!open && 'hidden'}`}>
          {
            navbarLinks.map((link, index) => (link.internal ? (
              <li key={index} className='md:ml-8 md:my-0 my-4 text-base'>
                <Link
                  to={link.link}
                  onClick={toggle}
                  className='hover:no-underline transition-colors text-gray-800 hover:text-sky-500 block py-2'> {link.name}</Link>
              </li>
            ) : (
              <li
                key={index}
                className="md:ml-8 md:my-0 my-4 text-base"
              >
                <a
                  href={link.link}
                  target={link.target}
                  onClick={toggle}
                  rel="noopener noreferrer"
                  className="hover:no-underline transition-colors text-gray-800 hover:text-sky-500 block py-2"
                >
                  {link.name}
                </a>
              </li>
            )
            ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;